import {
    Box,
    FormLabel,
    Grid,
    IconButton,
    Stack,
    Tab,
    Tabs,
    TextField,
    Tooltip,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    TextareaAutosize,
    CircularProgress
  } from "@mui/material";
  import { DataGrid } from "@mui/x-data-grid";
  import { useSelector } from "react-redux";
  import format from "date-fns/format";
  import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
  import { AgedDebtDueAPI, AgedDebtDueManagementAPI } from "../../Services/api";
  import { useEffect, useState, useRef } from "react";
  import instance from "../../redux/api";
  import { CommonPaginationContainer, CommonSelect } from "../common";
  import { CommonButton } from "../common/commonButton";
  import { numberFormatter } from "../../utils/generalFunctions";
  import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
  import "../../assets/scss/common.scss";
  import { customDateFormat, getPaginationCount } from "../CashAllocation/utils";
  import dayjs from "dayjs";
  import { toast } from "react-toastify";
  import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
  import FilterListIcon from "@mui/icons-material/FilterList";
  import CloseIcon from "@mui/icons-material/Close";
  import DownloadIcon from "@mui/icons-material/DownloadOutlined";
  import { commonToast } from "../common";
  import CustomDateRangePicker from "../common/CustomDateRangePicker";

  export const AgedDebtDueView = () => {
    const toggle = useSelector((state) => state.toggleSideMenu);
    const { userData } = useSelector((state) => state?.user);
    const [searchFieldsPrams, setSearchFieldsPrams] = useState({
      Broker: [],
      lob: "",
      yoa: [],
      policy_ref: "",
      mop_mapped: [],
      market_source: [],
      broker_reference: [],
      insured: [],
      umr: [],
      file_name: "",
      entity: [],
      underwriter: [],
      status_sett: [],
      status_usd: []
    });

    const [tabValue, setTabValue] = useState(1);

    const [isSearchPerformed, setIsSearchPerformed] = useState(false);
    const [isClearPerformed, setIsClearPerformed] = useState(false);

    //For pagination
    const [paginationCount, setPaginationCount] = useState(0);
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [pageState, setPageState] = useState({
      isLoading: true,
      data: [],
      total: 0,
      page: 1,
      pageSize: 25,
    });

    //For Date picker
    const [fromInceptionDateValue, setFromInceptionDateValue] = useState("");
    const [toInceptionDateValue, setToInceptionDateValue] = useState("");
    const [fromDueDateValue, setFromDueDateValue] = useState("");
    const [toDueDateValue, setToDueDateValue] = useState("");

    // State to store totals from API response
    const [totals, setTotals] = useState({
      total_prem_due_sett: 0.00,
      total_prem_due_usd: 0.00,
      total_cash_rec_sett: 0.00,
      total_cash_rec_usd: 0.00,
      total_alloc_amt_sett: 0.00,
      total_alloc_amt_usd: 0.00,
      total_cash_unalloc_sett: 0.00,
      total_cash_unalloc_usd: 0.00,
      total_uncollected_prem_sett: 0.00,
      total_uncollected_prem_usd: 0.00,

      total_uncollected_notyet_due_sett: 0.00,
      total_uncollected_notyet_due_usd: 0.00,
      total_uncollected_overdue_sett: 0.00,
      total_uncollected_overdue_usd: 0.00
    });

    const [openCommentsDialog, setOpenCommentsDialog] = useState(null);
    const [currentRowId, setCurrentRowId] = useState(null);
    const [dialogCommentsValue, setDialogCommentsValue] = useState("");
    const [oldConcatenatedComment, setOldConcatenatedComment] = useState("");
    const [commentType, setCommentType] = useState("");
    const [dropdownType, setDropdownType] = useState(""); // Add new state to track dropdown type (action or category)

    // Track original values
    const [originalCCComment, setOriginalCCComment] = useState("");
    const [originalUnderwriterComment, setOriginalUnderwriterComment] = useState("");
    const [originalAction, setOriginalAction] = useState("");
    const [originalCategory, setOriginalCategory] = useState("");

    // Track current values
    const [currentCCComment, setCurrentCCComment] = useState("");
    const [currentUnderwriterComment, setCurrentUnderwriterComment] = useState("");
    const [currentAction, setCurrentAction] = useState("");
    const [currentCategory, setCurrentCategory] = useState("");

    // Track which rows have modified fields
    const [modifiedRows, setModifiedRows] = useState({});

    // Helper function to mark a row as modified and store current values
    const markRowAsModified = (rowId, fieldType, isModified, currentValue = null) => {
      setModifiedRows(prev => {
        // Create a new object to avoid mutation
        const newState = { ...prev };

        // Initialize the row if it doesn't exist
        if (!newState[rowId]) {
          newState[rowId] = {
            cc_comments: { modified: false, value: null },
            underwriter_comments: { modified: false, value: null },
            action: { modified: false, value: null },
            category: { modified: false, value: null }
          };
        }

        // Update the specific field
        newState[rowId][fieldType] = {
          modified: isModified,
          value: currentValue
        };

        // If no fields are modified, remove the row
        if (!Object.values(newState[rowId]).some(field => field.modified)) {
          delete newState[rowId];
        }

        return newState;
      });

      // Also update the current value state variables for easy access
      if (currentValue !== null) {
        switch (fieldType) {
          case 'cc_comments':
            setCurrentCCComment(currentValue);
            break;
          case 'underwriter_comments':
            setCurrentUnderwriterComment(currentValue);
            break;
          case 'action':
            setCurrentAction(currentValue);
            break;
          case 'category':
            setCurrentCategory(currentValue);
            break;
          default:
            break;
        }
      }
    };

    // Track current row data
    const [currentRowData, setCurrentRowData] = useState(null);

    // Safely parse JSON-like strings; return original value if not JSON
    const safeParseJson = (value) => {
      if (value === null || value === undefined) return null;
      if (typeof value === "string") {
        const text = value.trim();
        // First try standard JSON
        try {
          return JSON.parse(text);
        } catch (_) {
          // Attempt to normalize Python-like repr to JSON
          try {
            const normalized = text
              .replace(/\bNone\b/g, "null")
              .replace(/\bTrue\b/g, "true")
              .replace(/\bFalse\b/g, "false")
              .replace(/'/g, '"');
            return JSON.parse(normalized);
          } catch (_) {
            return value;
          }
        }
      }
      return value;
    };

    // From an input that may be string/obj/array, pick the latest object by "no"
    const getLatestByNo = (input) => {
      const data = safeParseJson(input);
      if (Array.isArray(data)) {
        const items = data.filter((item) => item && typeof item === "object");
        console.log("items", items)
        if (items.length === 0) return null;
        const withNo = items.filter((it) => it?.no !== undefined && it?.no !== null);
        console.log("withNo", withNo)
        if (withNo.length > 0) {
          return withNo.reduce((acc, cur) => (Number(cur.no) > Number(acc.no) ? cur : acc));
        }
        console.log("items[items.length - 1]", items[items.length - 1])
        return items[items.length - 1];
      }
      return data;
    };

    // Get the displayable text from the latest object
    const getLatestValueText = (input) => {
      const latest = getLatestByNo(input);
      if (latest === null || latest === undefined) return "";
      if (typeof latest === "object") {
        return latest.value ?? latest.comment ?? JSON.stringify(latest);
      }
      return latest;
    };

    // skip 0 means page 1
    const currentSkipNumber = () => {
      return pageState?.page === 1
        ? 0
        : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
    };

    useEffect(() => {
      setPaginationCount(getPaginationCount(pageState?.total, pageState?.pageSize));
    }, [pageState?.total]);

    const loadData = async () => {
      suppressEffects.current = true;
      try {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));

        let queryParams = `skip=${currentSkipNumber()}&pageSize=${
          pageState?.pageSize
        }`;

        // if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
        // }

        const response = await instance.get(
          `${AgedDebtDueAPI}?due=${tabValue}&${queryParams}`
        );

        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));

        handleVarianceResponse(response);
        setMOPMappedList(response?.data?.mop_mapped);
        setMarketSourceList(response?.data?.market_source);
        setBrokerReferenceList(response?.data?.broker_reference);
        setInsuredList(response?.data?.insured);
        setUmrList(response?.data?.umr);
        setFileNameList(response?.data?.file_name)
        setEntityList(response?.data?.entity)
        setUnderWriterList(response?.data?.underwriter)
        setStatusSettList(response?.data?.status_sett)
        setStatusUSDList(response?.data?.status_usd)
        setIsClearPerformed(false);

        // Default select a file_name from any row if not already selected
        try {
          if (!searchFieldsPrams?.file_name) {
            const defaultFileName = (response?.data?.data || []).find(row => row?.file_name)?.file_name;
            if (defaultFileName) {
              setSearchFieldsPrams(prev => ({ ...prev, file_name: defaultFileName }));
            }
          }
        } catch (_) {
          // no-op
        }
      } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));
        setPaginationCount(0);
        console.error("err", err);
      } finally {
        // Stop suppressing effects
        suppressEffects.current = false;
      }
    };

    const handleClearSearchList = (functionalityType) => {
      if(functionalityType=="Clear"){
        setIsClearPerformed(true);
        setFromInceptionDateValue("");
        setToInceptionDateValue("");
        setFromDueDateValue("");
        setToDueDateValue("");
        setPolicyNumber("");
        // clear fields
        setSearchFieldsPrams(prev => ({
          Broker: [],
          lob: "",
          yoa: [],
          policy_ref: "",
          mop_mapped: [],
          market_source: [],
          broker_reference: [],
          insured: [],
          umr: [],
          // preserve previous file_name value
          file_name: prev.file_name,
          entity: [],
          underwriter: [],
          status_sett: [],
          status_usd: []
        }));
      }
      setIsSearchPerformed(false);
      // Reset page to 1
      setPageState(old => ({
        ...old,
        page: 1
      }));
    };

    const isFilterBtnDisable = () => {
      let disabled = true;
      const { Broker, lob, yoa, policy_ref, mop_mapped, market_source, broker_reference, insured, umr, file_name, entity, underwriter, status_sett, status_usd } = searchFieldsPrams;
      if (
        (Broker && Broker.length > 0) ||
        lob !== "" ||
        (yoa && yoa.length > 0) ||
        policy_ref !== "" ||
        (mop_mapped && mop_mapped.length > 0) ||
        (market_source && market_source.length > 0) ||
        (broker_reference && broker_reference.length > 0) ||
        (insured && insured.length > 0) ||
        (umr && umr.length > 0) ||
        file_name !== "" || 
        (entity && entity.length > 0) ||
        (underwriter && underwriter.length > 0) ||
        (status_sett && status_sett.length > 0) ||
        (status_usd && status_usd.length > 0)
      ) {
        disabled = false;
      }
      return disabled;
    };

    const classes = useStyles();

    const handleVarianceResponse = (response) => {
      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));

        if (response?.data?.summary) {
          setTotals(response.data.summary);
        }

        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    };

    const handleTabChange = async (event, newValue) => {
      handleClearSearchList("tabChange");

      setTabValue(newValue);

      try {
        if (pageState?.page == 1) {
          setPageState((old) => ({
            ...old,
            page: 1,
            pageSize:25,
            isLoading: true,
          }));

          const getSearchQueryParam = searchQueryParams();

          const response = await instance.get(
            `${AgedDebtDueAPI}?due=${newValue}&skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}${getSearchQueryParam}`
          );

          setPageState((old) => ({
            ...old,
            isLoading: false,
          }));

          handleVarianceResponse(response);
        } else {
          setPageState((old) => ({
            ...old,
            page: 1,
            pageSize:25,
            isLoading: true,
          }));
        }
      } catch {
        setPageState((old) => ({
          ...old,
          isLoading: false,
          total: 0,
          data: [],
        }));
      }
    };

    const handleActionRequiredChange = async (rowId, value, reason, type) => {
      if (reason === "blur") {
        return;
      }

      // Store the current row ID
      setCurrentRowId(rowId);

      // Get the row data if not already stored
      if (!currentRowData || currentRowData.id !== rowId) {
        const rowData = pageState.data.find(row => row.id === rowId);
        setCurrentRowData(rowData);

        // Store original values if not already stored
        if (type === "action") {
          const originalValue = rowData?.aged_debt_due_management?.action || "";
          setOriginalAction(originalValue);
          const isModified = value !== originalValue;
          markRowAsModified(rowId, "action", isModified, value);
        } else if (type === "category") {
          const originalValue = rowData?.aged_debt_due_management?.category || "";
          setOriginalCategory(originalValue);
          const isModified = value !== originalValue;
          markRowAsModified(rowId, "category", isModified, value);
        }
      } else {
        // Check if the value has been modified from its original value
        if (type === "action") {
          const isModified = value !== originalAction;
          markRowAsModified(rowId, "action", isModified, value);
        } else if (type === "category") {
          const isModified = value !== originalCategory;
          markRowAsModified(rowId, "category", isModified, value);
        }
      }

      // We're not calling the API yet as per instructions
      // Just tracking the changes for now
    };

    // Function to check if a specific row has any modified fields
    const isRowModified = (rowId) => {
      return modifiedRows[rowId] !== undefined;
    };

    // Function to get the current display value of a field
    const getDisplayValue = (rowId, fieldType, originalValue) => {
      // If the row has been modified and this field has been changed, return the modified value
      if (modifiedRows[rowId] && modifiedRows[rowId][fieldType] && modifiedRows[rowId][fieldType].modified) {
        return modifiedRows[rowId][fieldType].value;
      }
      // Otherwise return the original value
      return originalValue;
    };

    const handleActionButton = async (row) => {
      // Get the current state of all modifiable fields for this row
      const rowModifications = modifiedRows[row.id] || {};

      try {
        // Prepare payload with only modified fields
        const payload = {};
        Object.entries(rowModifications).forEach(([field, data]) => {
          if (data.modified) {
            payload[field] = data.value;
          }
        });

        // Add updated_by to payload
        payload.updated_by = userData?.id;
        payload.agedebt_id = row?.id;
        payload.file_name = row?.file_name;
        payload.status_usd = row?.status_usd;
        payload.installment_due_date = row?.installment_due_date;

        let response;
        if (row?.aged_debt_due_management) {
          // If management record exists, use PATCH
          payload.id = row.id;
          response = await instance.patch(
            `${AgedDebtDueManagementAPI}${row.aged_debt_due_management.id}/`,
            payload
          );
        } else {
          payload.policy_id = row?.policy;
          payload.installment_number = row?.installment_number;
          response = await instance.post(AgedDebtDueManagementAPI, payload);
        }

        if (response?.status === 200 || response?.status === 201) {
          toast.success("Changes saved successfully!", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 1000,
          });

          // Refresh the data
          loadData();
        }
      } catch (error) {
        console.error("Error saving changes:", error);
        toast.error("Failed to save changes", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
      }

      // After saving, reset the modification flags for this row
      setModifiedRows(prev => {
        const newState = { ...prev };
        delete newState[row.id];
        return newState;
      });
    };

    const [isDownloadInProgress, setIsDownloadInProgress] = useState(false);
    const handleDownload = async () => {
      setIsDownloadInProgress(true);
      const getSearchQueryParam = searchQueryParams();
      try {
        instance
          .get(`${AgedDebtDueAPI}?download=report${getSearchQueryParam}&due=${tabValue}`, { responseType: "blob" })
          .then((response) => {
            const url = URL.createObjectURL(response.data);
            const link = document.createElement("a");
            link.href = url;
            const fileName = `Aged Report ${format(new Date(), "dd-MM-yyyy")}`;
            link.setAttribute("download", `${fileName}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            setIsDownloadInProgress(false);
            commonToast("success", "File has been downloaded successfully");
          })
          .catch((err) => {
            setIsDownloadInProgress(false);
            commonToast("error", "File could not be downloaded");
          });
      } catch (error) {
        setIsDownloadInProgress(false);
        commonToast("error", "File could not be downloaded");
      }
    };

    const columns = [
      {
        field: "yoa",
        headerName: "YOA",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.yoa,
        renderCell: (params) => (
          <Tooltip title={params?.row?.yoa}>
            <span>{params?.row?.yoa?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "entity_name",
        headerName: "Entity",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.producing_entity,
        renderCell: (params) => (
          <Tooltip title={params?.row?.producing_entity}>
            <span>{params?.row?.producing_entity?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "lob",
        headerName: "LOB",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.policy?.substring(1, 3),
        renderCell: (params) => (
          <Tooltip title={params?.row?.policy?.substring(1, 3)}>
            <span>{params?.row?.policy?.substring(1, 3)?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "market_source",
        headerName: "Market Source",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.market_source,
        renderCell: (params) => (
          <Tooltip title={params?.row?.market_source}>
            <span>{params?.row?.market_source?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "mop",
        headerName: "Mapped MOP",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.mop,
        renderCell: (params) => (
          <Tooltip title={params?.row?.mop}>
            <span>{params?.row?.mop?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "umr",
        headerName: "UMR",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.umr,
        renderCell: (params) => { return params?.row?.umr ?? "-" }
      },
      {
        field: "underwriter",
        headerName: "Underwriter",
        headerAlign: "center",
        width: 160,
        valueGetter: (params) => params?.row?.underwriter,
        renderCell: (params) => (
          <Tooltip title={params?.row?.underwriter}>
            <span>{params?.row?.underwriter?.substr(0, 20) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "master_broker",
        headerName: "Master Broker",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.master_broker,
        renderCell: (params) => (
          <Tooltip title={params?.row?.master_broker}>
            <span>{params?.row?.master_broker?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "broker_branch",
        headerName: "Broker Branch",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.broker_branch,
        renderCell: (params) => (
          <Tooltip title={params?.row?.broker_branch}>
            <span>{params?.row?.broker_branch?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "broker_reference",
        headerName: "Broker Reference",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.broker_reference,
        renderCell: (params) => (
          <Tooltip title={params?.row?.broker_reference}>
            <span>{params?.row?.broker_reference?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "policy",
        headerName: "Policy ref",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.policy,
        renderCell: (params) => (
          <Tooltip title={params?.row?.policy}>
            <span>{params?.row?.policy ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "insured",
        headerName: "Insured",
        headerAlign: "center",
        width: 150,
        valueGetter: (params) => params?.row?.insured,
        renderCell: (params) => (
          <Tooltip title={params?.row?.insured}>
            <span>{params?.row?.insured?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "inception_date",
        headerName: "Inception Date",
        headerAlign: "center",
        width: 120,
        renderCell: (params) => (params?.row?.inception_date ? customDateFormat(params.row.inception_date) : "-")
      },
      {
        field: "expired_date",
        headerName: "Expiry Date",
        headerAlign: "center",
        width: 120,
        renderCell: (params) => (params?.row?.expired_date ? customDateFormat(params.row.expired_date) : "-")
      },
      {
        field: "policy_status",
        headerName: "Policy Status",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.policy_status,
        renderCell: (params) => (
          <Tooltip title={params?.row?.policy_status}>
            <span>{params?.row?.policy_status?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "transaction_status",
        headerName: "Transaction Status",
        headerAlign: "center",
        width: 100,
        valueGetter: (params) => params?.row?.transaction_status,
        renderCell: (params) => (
          <Tooltip title={params?.row?.transaction_status}>
            <span>{params?.row?.transaction_status?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "bank_name",
        headerName: "Bank Name",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          <Tooltip title={params?.row?.bank_name}>
            <span>{params?.row?.bank_name?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        }
      },
      {
        field: "bank_account_number",
        headerName: "Bank Account Number",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          <Tooltip title={params?.row?.bank_account_number}>
            <span>{params?.row?.bank_account_number?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        }
      },
      // {
      //   field: "claims",
      //   headerName: "Claims",
      //   headerAlign: "center",
      //   width: 100,
      //   valueGetter: (params) => params?.row?.claims,
      //   renderCell: (params) => (
      //     <Tooltip title={params?.row?.claims}>
      //       <span>{params?.row?.claims?.substr(0, 10) ?? "-"}</span>
      //     </Tooltip>
      //   ),
      // },
      {
        field: "installment_due_date",
        headerName: "Due Date",
        headerAlign: "center",
        width: 150,
        renderCell: (params) => {
          try {
            // Check if date exists and is valid
            if (params?.row?.installment_due_date) {
              const date = new Date(params.row.installment_due_date);
              if (!isNaN(date.getTime())) {
                return format(date, "dd-MM-yyyy");
              }
            }
            return "-";
          } catch (error) {
            console.error("Error formatting installment_due_date:", error);
            return "-";
          }
        },
      },
      // {
      //   field: "Aged_Bucket_By_Period_Receivable",
      //   headerName: "Aged",
      //   headerAlign: "center",
      //   width: 120,
      //   valueGetter: (params) => params?.row?.Aged_Bucket_By_Period_Receivable,
      //   renderCell: (params) => (
      //     <Tooltip title={params?.row?.Aged_Bucket_By_Period_Receivable}>
      //       <span>{params?.row?.Aged_Bucket_By_Period_Receivable?.substr(0, 10) ?? "-"}</span>
      //     </Tooltip>
      //   ),
      // },
      {
        field: "settlement_ccy",
        headerName: "Sett Ccy",
        headerAlign: "center",
        width: 80,
        valueGetter: (params) => params?.row?.settlement_ccy,
        renderCell: (params) => (
          <Tooltip title={params?.row?.settlement_ccy}>
            <span>{params?.row?.settlement_ccy?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "installment_amount_sett",
        headerName: "Total Premium Due Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.installment_amount_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_receivable_sett",
        headerName: "Total Cash Received Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.total_receivable_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_allocated_sett",
        headerName: "Allocated Amount Sett",
        headerAlign: "center",
        width: 180,
        valueGetter: (params) => params?.row?.total_allocated_sett,
        renderCell: (params) => {
          const value = params?.row?.total_allocated_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
      },
      {
        field: "ct_unallocated",
        headerName: "Cash Unallocated Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.ct_unallocated;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "balance_after_subtraction_sett",
        headerName: "Uncollected Premium Sett",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.balance_after_subtraction_sett;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "ytbp_ageing_sett",
        headerName: "Aged Bucket Sett",
        headerAlign: "center",
        width: 120,
        valueGetter: (params) => params?.row?.ytbp_ageing_sett,
        renderCell: (params) => (
          <Tooltip title={params?.row?.ytbp_ageing_sett}>
            <span>{params?.row?.ytbp_ageing_sett?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "installment_amount_usd",
        headerName: "Total Premium Due USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.installment_amount_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_receivable_usd",
        headerName: "Total Cash Received USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.total_receivable_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "total_allocated_usd",
        headerName: "Allocated Amount USD",
        headerAlign: "center",
        width: 180,
        valueGetter: (params) => params?.row?.total_allocated_usd,
        renderCell: (params) => {
          const value = params?.row?.total_allocated_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
      },
      {
        field: "ct_unallocated_usd",
        headerName: "Cash Unallocated USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.ct_unallocated_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "balance_after_subtraction_usd",
        headerName: "Uncollected Premium USD",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => {
          const value = params?.row?.balance_after_subtraction_usd;
          return value && value !== null && value !== undefined && value !== "" 
            ? numberFormatter(value) 
            : "-";
        },
        cellClassName: "amount-table-cell",
      },
      {
        field: "ytbp_ageing_usd",
        headerName: "Aged Bucket USD",
        headerAlign: "center",
        width: 130,
        valueGetter: (params) => params?.row?.ytbp_ageing_usd,
        renderCell: (params) => (
          <Tooltip title={params?.row?.ytbp_ageing_usd}>
            <span>{params?.row?.ytbp_ageing_usd?.substr(0, 10) ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "cc_comments",
        headerName: "CC Comments",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
              <div
              onClick={() =>
                handleCommentsOpenDialog(params?.row?.id, params?.row?.aged_debt_due_management?.cc_comments, "cc_comments")
              }
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    width: 200,
                    gap: 5,
                    // padding: "10px",
                    paddingLeft: "5%"
                  }}
                >
                  <div
                    style={{
                      overflow: "hidden",
                      textWrap: "nowrap",
                      // textOverflow: "ellipsis",
                    }}
                  >
                    {(() => {
                      const raw = params?.row?.aged_debt_due_management?.cc_comments;
                      if (typeof raw === "string" && raw?.toLowerCase() === "nan") return "";
                      const display = getLatestValueText(raw);
                      return getDisplayValue(params.row.id, "cc_comments", display ?? "");
                    })()}
                  </div>
                  <MoreHorizIcon />
                </div>
              </div>
            ):
              <div>
                {(() => {
                  const raw = params?.row?.aged_debt_due_management?.cc_comments;
                  const display = getLatestValueText(raw);
                  if (display === null || display === undefined || display === "") return "-";
                  return display;
                })()}
              </div>
            }
          </>
        ),
      },
      {
        field: "action",
        headerName: "Action Required",
        headerAlign: "center",
        width: 175,
        valueGetter: (params) => getDisplayValue(
          params.row.id,
          "action",
          params?.row?.aged_debt_due_management?.action || ""
        ),
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
              <div style={{ width: "100%" }}>
                <CommonSelect
                  placeholder="Select Action"
                  value={getDisplayValue(
                    params.row.id,
                    "action",
                    params?.row?.aged_debt_due_management?.action || ""
                  )}
                  handleChange={(event, value, reason) =>
                    handleActionRequiredChange(params.row.id, value, reason, "action")
                  }
                  options={actionList || []}
                  size="small"
                  customStyles={{ minWidth: "100%", fontSize: "0.8rem" }}
                />
              </div>
            ):
              <div>
                {params?.row?.aged_debt_due_management?.action ?? "-"}
              </div>
            }
          </>
        ),
      },
      {
        field: "category",
        headerName: "Category",
        headerAlign: "center",
        width: 175,
        valueGetter: (params) => getDisplayValue(
          params.row.id,
          "category",
          params?.row?.aged_debt_due_management?.category || ""
        ),
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
              <div style={{ width: "100%" }}>
                <CommonSelect
                  placeholder="Select Category"
                  value={getDisplayValue(
                    params.row.id,
                    "category",
                    params?.row?.aged_debt_due_management?.category || ""
                  )}
                  handleChange={(event, value, reason) =>
                    handleActionRequiredChange(params.row.id, value, reason, "category")
                  }
                  options={categoryList || []}
                  size="small"
                  customStyles={{ minWidth: "100%", fontSize: "0.8rem" }}
                />
              </div>
            ):
              <div>
                {params?.row?.aged_debt_due_management?.category ?? "-"}
              </div>
            }
          </>
        ),
      },
      {
        field: "underwriter_comments",
        headerName: "Underwriter Comments",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => (
          <>
            {UserAuthorisation?.["Edit"] === "Y" && params?.row?.status_usd !== "Paid" ? (
            <div
              onClick={() =>
                handleCommentsOpenDialog(params?.row?.id, params?.row?.aged_debt_due_management?.underwriter_comments, "underwriter_comments")
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  width: 200,
                  gap: 5,
                  // padding: "10px",
                  paddingLeft: "5%"
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    textWrap: "nowrap",
                    // textOverflow: "ellipsis",
                  }}
                >
                  {(() => {
                    const raw = params?.row?.aged_debt_due_management?.underwriter_comments;
                    if (typeof raw === "string" && raw?.toLowerCase() === "nan") return "";
                    const display = getLatestValueText(raw);
                    return getDisplayValue(params.row.id, "underwriter_comments", display ?? "");
                  })()}
                </div>
                <MoreHorizIcon />
              </div>
            </div>
            ):
              <div>
                {(() => {
                  const raw = params?.row?.aged_debt_due_management?.underwriter_comments;
                  const display = getLatestValueText(raw);
                  if (display === null || display === undefined || display === "") return "-";
                  return display;
                })()}
              </div>
            }
          </>
        ),
      },
      {
        field: "updated_at",
        headerName: "Updated Date",
        headerAlign: "center",
        width: 175,
        renderCell: (params) => {
          try {
            // Check if date exists and is valid - updated_at is directly on the row, not in aged_debt_due_management
            const dateValue = params?.row?.aged_debt_due_management?.updated_at;
            if (dateValue) {
              const date = customDateFormat(dateValue);
              if (!isNaN(date.getTime())) {
                return format(date, "dd-MM-yyyy");
              }
            }
            return "-";
          } catch (error) {
            console.error("Error formatting updated_at:", error);
            return "-";
          }
        },
      },
      {
        field: "updated_by",
        headerName: "Updated By",
        headerAlign: "center",
        width: 175,
        valueGetter: (params) => params?.row?.aged_debt_due_management?.updated_by,
        renderCell: (params) => (
          <Tooltip title={params?.row?.aged_debt_due_management?.updated_by}>
            <span>{params?.row?.aged_debt_due_management?.updated_by ?? "-"}</span>
          </Tooltip>
        ),
      },
      {
        field: "actions",
        type: "actions",
        headerName: "Actions",
        flex: 1,
        minWidth: 100,
        description: "This column has a value getter and is not sortable.",
        cellClassName: "actions",
        getActions: ({ row }) => {
          let actionsList = [];
          actionsList.push(
            <CommonButton
                text="Save"
                handleClick={() => handleActionButton(row)}
                hoverColor="#EE3F00"
                disabled={UserAuthorisation?.["Edit"] !== "Y" || !isRowModified(row.id)}
              />
          );
          return actionsList;
        },
      }
    ]

    const [brokerList, setBrokerList] = useState([]);
    const [lobList, setLOBList] = useState([]);
    const [yoaList, setYOAList] = useState([]);
    const [policyNumber, setPolicyNumber] = useState("");
    const [MOPMappedList, setMOPMappedList] = useState("");
    const [marketSourceList, setMarketSourceList] = useState("");
    const [brokerReferenceList, setBrokerReferenceList] = useState("");
    const [insuredList, setInsuredList] = useState("");
    const [umrList, setUmrList] = useState("");
    const [fileNameList, setFileNameList] = useState("");
    const [entityList, setEntityList] = useState("");
    const [underWriterList, setUnderWriterList] = useState("");
    const [statusSettList, setStatusSettList] = useState("");
    const [statusUSDList, setStatusUSDList] = useState("");
    const [isPolicySearchInProgress, setIsPolicySearchInProgress] = useState(false);
    const [policyOptions, setPolicyOptions] = useState([]);
    const [actionList, setActionList] = useState([]);
    const [categoryList, setCategoryList] = useState([]);
    const suppressEffects = useRef(false);

    const getBrokerList = async () => {
      const response = await instance.get("documents/get_broker_list/");
      setBrokerList(response?.data?.Broker_Name);
    }

    const getLOBList = async () => {
      const response = await instance.get("documents/lob_filter/");
      setLOBList(response?.data?.data);
    }

    const getYOAList = async () => {
      const response = await instance.get("documents/yoa_filter/");
      setYOAList(response?.data?.data);
    }

    const getAgedDebtActionList = async () => {
      const response = await instance.get("documents/aged_debt_action_filter/");
      setActionList(response?.data?.data);
    }

    const getAgedDebtCategoryList = async () => {
      const response = await instance.get("documents/aged_debt_category_filter/");
      setCategoryList(response?.data?.data);
    }

    const getPolicyList = async (inputText) => {
      if (inputText?.length > 2) {
        try {
          setIsPolicySearchInProgress(true);
          const response = await instance.get(
            `documents/policy_line_ref/?policy_line_ref=${inputText}`
          );

          const allPolicies = response.data["all_policies"];
          // Check if the allPolicies array is empty
          setPolicyOptions(allPolicies);
          setIsPolicySearchInProgress(false);
        } catch (error) {
          setIsPolicySearchInProgress(false);
          console.error("Error fetching policies:", error);
        }
      }
    };

    useEffect(() => {
      getBrokerList()
      getLOBList()
      getYOAList()
      getPolicyList()
      getAgedDebtActionList()
      getAgedDebtCategoryList()
    }, [])

    const handleCommentsOpenDialog = (currentRowId, currentRowCommentData, type) => {
      setOpenCommentsDialog(true);
      setCurrentRowId(currentRowId);
      const latestText = getLatestValueText(currentRowCommentData);
      setDialogCommentsValue(getDisplayValue(currentRowId, type, latestText ?? ""));
      // Store the full comment data for displaying old comments
      setOldConcatenatedComment(currentRowCommentData);
      setCommentType(type); // Set the comment type (cc_comments or underwriter_comments)

      // Store the original comment value for comparison
      if (type === "cc_comments") {
        setOriginalCCComment(latestText ?? "");
      } else if (type === "underwriter_comments") {
        setOriginalUnderwriterComment(latestText ?? "");
      }
    };

    const handleCloseDialogs = () => {
      setOpenCommentsDialog(false);
      setDialogCommentsValue("");
      setCurrentRowId(null);
    };

    const handleDialogInputChange = (e) => {
      const newValue = e.target.value;
      setDialogCommentsValue(newValue);
    };

    const handleSaveComments = (value) => {
      // Check if the comment has been modified from its original value
      if (commentType === "cc_comments") {
        const isModified = value !== originalCCComment;
        markRowAsModified(currentRowId, "cc_comments", isModified, value);
      } else if (commentType === "underwriter_comments") {
        const isModified = value !== originalUnderwriterComment;
        markRowAsModified(currentRowId, "underwriter_comments", isModified, value);
      }
      setOpenCommentsDialog(false);

      // Only process if there's a new comment
      if (dialogCommentsValue) {

        // Mark the row as modified
        if (commentType === "cc_comments") {
          markRowAsModified(currentRowId, "cc_comments", true, dialogCommentsValue);
        } else if (commentType === "underwriter_comments") {
          markRowAsModified(currentRowId, "underwriter_comments", true, dialogCommentsValue);
        }

        // Store the updated comment for later use when saving
        if (commentType === "cc_comments") {
          setOriginalCCComment(dialogCommentsValue);
        } else if (commentType === "underwriter_comments") {
          setOriginalUnderwriterComment(dialogCommentsValue);
        }
      }

      handleCloseDialogs();
    };

    const agedDebtDueContainer = {
      width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
      height: "525px",
    };

    const agedDebtDueText = {
      display: "flex",
      justifyContent: "space-between",
      fontWeight: "400",
      marginTop: 5,
    };

    const handleCommonDropdown = (name, value, reason, clearKey, hooks, isMulti) => {
      if (reason === "clear") {
        if (hooks && typeof hooks.onClear === "function") hooks.onClear();
        setSearchFieldsPrams(prev => ({ ...prev, [name]: isMulti ? [] : "", [clearKey]: "" }));
      } else {
        if (hooks && typeof hooks.onChange === "function") hooks.onChange(value);
        if (isMulti) {
          // value will be an array of selected items
          setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
        } else {
          setSearchFieldsPrams(prev => ({ ...prev, [name]: value }));
        }
      }
    };

    // Single entry point for all filters using name -> clearKey and hooks maps
    const clearKeyFor = {
      Broker: "Broker",
      lob: "lob",
      yoa: "yoa",
      policy_ref: "policy_ref",
      mop_mapped: "mop_mapped",
      market_source: "market_source",
      broker_reference: "broker_reference",
      insured: "insured",
      umr: "umr",
      file_name: "file_name",
      entity: "entity",
      underwriter: "underwriter",
      status_sett: "status_sett",
      status_usd: "status_usd",
    };

    const hooksFor = {
      policy_ref: {
        onClear: () => setPolicyNumber(""),
        onChange: v => setPolicyNumber(v)
      }
    };

    const handleFilterDropdown = (name, value, reason, isMulti = false) => {
      const clearKey = clearKeyFor[name] || name;
      const hooks = hooksFor[name];
      handleCommonDropdown(name, value, reason, clearKey, hooks, isMulti);
    };

    // All specific dropdowns should directly call handleFilterDropdown from UI

    const handleInputChage = (inputValue) => {
      let value = inputValue.toUpperCase().replace(/[^A-Z0-9]/g, "");
      value = value.slice(0, 12);

      if (
        value.charAt(0) !== "P" &&
        value.charAt(0) !== "M" &&
        value.charAt(0) !== "F"
      ) {
        value = value.slice(0, 1);
      }
      setPolicyNumber(value);
      // Keep search params in sync so Search button enables on paste/typing
      setSearchFieldsPrams(prev => ({ ...prev, policy_ref: value }));
      getPolicyList(value);
    };

    const searchQueryParams = () => {
      let getSearchQueryParams = "";
      const { Broker, lob, yoa, policy_ref, mop_mapped, market_source, broker_reference, insured, umr, file_name, entity, underwriter, status_sett, status_usd } = searchFieldsPrams;

      if (Broker.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&Broker=${encodeURIComponent(Broker.join(','))}`
      }

      if (lob) {
        getSearchQueryParams = `${getSearchQueryParams}&lob=${lob}}`
      }

      if (yoa.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&yoa=${encodeURIComponent(yoa.join(','))}`
      }

      if (policy_ref) {
        getSearchQueryParams = `${getSearchQueryParams}&policy_ref=${policy_ref}`
      }

      if (mop_mapped.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&mop_mapped=${encodeURIComponent(mop_mapped.join(','))}`
      }

      if (market_source.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&market_source=${encodeURIComponent(market_source.join(','))}`
      }

      if (broker_reference.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&broker_reference=${encodeURIComponent(broker_reference.join(','))}`
      }

      if (insured.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&insured=${encodeURIComponent(insured.join(','))}`
      }

      if (umr.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&umr=${encodeURIComponent(umr.join(','))}`
      }

      if (file_name) {
        getSearchQueryParams = `${getSearchQueryParams}&file_name=${file_name}`
      }
      
      if (entity.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&entity=${encodeURIComponent(entity.join(','))}`
      }

      if (underwriter.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&underwriter=${encodeURIComponent(underwriter.join(';'))}`
      }

      if (status_sett.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&status_sett=${encodeURIComponent(status_sett.join(','))}`
      }

      if (status_usd.length > 0) {
        getSearchQueryParams = `${getSearchQueryParams}&status_usd=${encodeURIComponent(status_usd.join(','))}`
      }

      let formattedFromInceptionDateValue = "", formattedToInceptionDateValue = "";

      if (fromInceptionDateValue && toInceptionDateValue) {
        formattedFromInceptionDateValue = format(fromInceptionDateValue, "dd/MM/yyyy");
        formattedToInceptionDateValue = format(toInceptionDateValue, "dd/MM/yyyy");
        getSearchQueryParams = `${getSearchQueryParams}&fromInceptionDate=${formattedFromInceptionDateValue}&toInceptionDate=${formattedToInceptionDateValue}`;
      }

      let formattedFromDueDateValue = "", formattedToDueDateValue = "";

      if (fromDueDateValue && toDueDateValue) {
        formattedFromDueDateValue = format(fromDueDateValue, "dd/MM/yyyy");
        formattedToDueDateValue = format(toDueDateValue, "dd/MM/yyyy");
        getSearchQueryParams = `${getSearchQueryParams}&fromDueDate=${formattedFromDueDateValue}&toDueDate=${formattedToDueDateValue}`;
      }

      return getSearchQueryParams;
    };

    const handleSearchBnkReconciliationList = async () => {
      try {
        let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }

        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
        
        const response = await instance.get(
          `${AgedDebtDueAPI}${queryParams}&due=${tabValue}`
        );
        
        setPageState((old) => ({
          ...old,
          isLoading: false,
        }));

        if (response.status === 200) {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count,
            data: response?.data?.data ? response?.data?.data : [],
            page: 1,
          }));
          
          // Update totals from API response
          if (response?.data?.summary) {
            setTotals(response.data.summary);
          }
          
          setIsSearchPerformed(true);
        } else {
          setPageState((old) => ({
            ...old,
            total: response?.data?.count ?? 0,
            data: [],
          }));
          setPaginationCount(0);
        }
    } catch (err) {
        setPageState((old) => ({
          ...old,
          isLoading: true,
        }));
        console.log("err", err);
      }
    };

    // Effects now check the suppress flag
    useEffect(() => {
      if (suppressEffects.current) return;
      loadData();
    }, [pageState?.pageSize, pageState?.page]);

    useEffect(() => {
      if (suppressEffects.current) return;
      if (isClearPerformed) {
        loadData();
      }
    }, [isClearPerformed]);  

    const UserAuthorisation = userData?.user_permissions?.permissions_list['Aged Debt Due'];

    const handleEnter = (e) => {
      if (e.code === "Enter") {
        handleSearchBnkReconciliationList();
      }
      window.scrollBy({
        top: 335,
        behavior: "smooth",
      });
    };

    const headerSx = {
      fontWeight: "bolder",
      fontSize: "12px",
      textAlign: "center",
      height: "32px",            // 🔑 forces equal header height
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      lineHeight: "1.1",
      whiteSpace: "normal",
    };

    const valueSx = {
      fontWeight: "400",
      fontSize: "11px",
      textAlign: "center"
    }
    return (
      <>
      <div>
        {UserAuthorisation?.["View"] === "Y" ? (
          <Box style={agedDebtDueContainer}>
            <div style={{display:"flex", justifyContent:"space-between"}}>
              <div style={agedDebtDueText}>
                <Typography
                  variant="h3"
                  style={{
                    color: "#FF5A01",
                    fontSize: "24px",
                    margin: "10px 0px 0px 0px",
                  }}
                >
                  Aged Report
                </Typography>
              </div>
              <div>
              <Typography
                  variant="h5"
                  style={{
                    fontWeight: "bolder",
                    fontSize: "16px",
                    margin: "15px 0px 0px 0px",
                  }}
                >
                  Selected File Name: {searchFieldsPrams?.file_name}
                </Typography>
              </div>
            </div>
            <Grid
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: "10px",
              }}
              xs={12}
              gap={"10px"}
            >
              <Grid sx={{
                display: "flex",
                alignItems: "center",
                gap:"10px"
              }}>
                {/* <Grid item>
                  <CommonButton
                    text="Search"
                    handleClick={handleSearchBnkReconciliationList}
                    hoverColor="#EE3F00"
                    disabled={pageState?.isLoading || isFilterBtnDisable()}
                  />
                </Grid> */}
                
                <Tooltip title={isFilterOpen ? "Close Filters" : "Open Filters"}>
                  <IconButton
                    onClick={() => setIsFilterOpen((prev) => !prev)}
                    aria-label={isFilterOpen ? "Close filters" : "Open filters"}
                    disabled={pageState?.isLoading}
                  >
                    {isFilterOpen ? (
                      <CloseIcon />
                    ) : (
                      <FilterListIcon />
                    )}
                  </IconButton>
                </Tooltip>
                <Grid item xs={1.5}>
                  <CommonButton
                    text="Clear"
                    handleClick={() => handleClearSearchList("Clear")}
                    hoverColor="#EE3F00"
                    disabled={pageState?.isLoading}
                  />
                </Grid>
                <CommonButton
                  text={isDownloadInProgress ? "Downloading" : "Download"}
                  hoverColor="#FF5A01"
                  icon={<DownloadIcon />}
                  handleClick={handleDownload}
                  disabled={isDownloadInProgress || pageState?.data?.length === 0 || pageState?.isLoading}
                />
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  style={{
                    border: " 1px solid black",
                    borderRadius: "9px",
                  }}
                  aria-label="disabled tabs example"
                  >
                  <Tab
                    style={{
                      borderRight: "1px solid black",
                      padding: "5px",
                      backgroundColor: tabValue === 0 ? "#FF5A01" : "",
                      color: tabValue == 0 ? "white" : "",
                      cursor: pageState?.isLoading ? "not-allowed" : "pointer",
                      opacity: pageState?.isLoading ? 0.6 : 1,
                    }}
                    label="Show All"
                    disabled={pageState?.isLoading}
                  />

                  <Tab
                    label="Due"
                    style={{
                      padding: "5px",
                      backgroundColor: tabValue === 1 ? "#FF5A01" : "",
                      color: tabValue == 1 ? "white" : "",
                      cursor: pageState?.isLoading ? "not-allowed" : "pointer",
                      opacity: pageState?.isLoading ? 0.6 : 1,
                    }}
                    disabled={pageState?.isLoading}
                  />
                </Tabs>
              </Grid>

              {/* Totals Display */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    borderRadius: "8px",
                    padding: "12px",
                    marginLeft: "20px",
                    minWidth: "45%",
                    maxWidth: "57%",
                  }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "80px 1fr 1fr 1fr 1fr 1fr 1fr",
                      gap: "6px",
                    }}
                  >
                    {/* Row Headers */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="caption" sx={{ ...headerSx, height: "32px" }}>
                        Total
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: "bolder", fontSize: "11px", textAlign: "center" }}>
                        Sett
                      </Typography>
                      <Typography variant="caption" sx={{ fontWeight: "bolder", fontSize: "11px", textAlign: "center" }}>
                        USD
                      </Typography>
                    </Box>

                    {/* Premium Due */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="caption" sx={headerSx}>
                        Prem Due
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_prem_due_sett)}
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_prem_due_usd)}
                      </Typography>
                    </Box>

                    {/* Cash Received */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="caption" sx={headerSx}>
                        Cash Rec
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_cash_rec_sett)}
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_cash_rec_usd)}
                      </Typography>
                    </Box>

                    {/* Allocated */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="caption" sx={headerSx}>
                        Alloc
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_alloc_amt_sett)}
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_alloc_amt_usd)}
                      </Typography>
                    </Box>

                    {/* Unallocated */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="caption" sx={headerSx}>
                        Unalloc
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_cash_unalloc_sett)}
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals.total_cash_unalloc_usd)}
                      </Typography>
                    </Box>

                    {/* Uncollected Not Yet Due */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="caption" sx={headerSx}>
                        Uncollected<br />Not yet due
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals?.total_uncollected_notyet_due_sett)}
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals?.total_uncollected_notyet_due_usd)}
                      </Typography>
                    </Box>

                    {/* Uncollected Overdue */}
                    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <Typography variant="caption" sx={headerSx}>
                        Uncollected<br />Overdue
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals?.total_uncollected_overdue_sett)}
                      </Typography>
                      <Typography variant="caption" sx={valueSx}>
                        {numberFormatter(totals?.total_uncollected_overdue_usd)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
            </Grid>

            <div
              style={{
                height: "calc(100vh - 313px)",
                position: "relative",
                display: "flex",
                flexDirection: "row-reverse",
              }}
            >
              <DataGrid
                className={classes.pagination}
                loading={pageState?.isLoading}
                rows={pageState?.data ?? []}
                columns={columns}
                rowCount={pageState?.total}
                keepNonExistentRowsSelected
                disableSelectionOnClick
                pagination
                paginationMode="server"
                // getRowId={(row) => row?.id}
                page={pageState.page - 1}
                pageSize={pageState?.pageSize ?? 25}
                rowsPerPageOptions={[10, 25, 50, 100]}
                onPageSizeChange={(newPageSize) => {
                  return setPageState((old) => {
                    setPaginationCount(getPaginationCount(pageState?.total, newPageSize))
                    return { ...old, pageSize: newPageSize, page: 1 };
                  });
                }}
                sx={{
                  "& .MuiDataGrid-cellContent": {
                    textAlign: "start",
                  },
                  "& .MuiDataGrid-columnHeader[data-field='Comments']": {
                    minWidth: toggle?.isOpen
                      ? "209.137px !important"
                      : "209.137px !important",
                  },
                }}
              />
              <Stack
                style={{
                  position: "absolute",
                  bottom: "8px",
                }}
              >
                <CommonPaginationContainer
                  count={paginationCount + 1}
                  pageState={pageState}
                  setPageState={setPageState}
                />
              </Stack>
            </div>
            <Dialog open={openCommentsDialog} onClose={handleCloseDialogs}>
              <DialogTitle>
                {commentType === "cc_comments" ? "CC Comment" : "Underwriter Comment"}
              </DialogTitle>
              <DialogContent sx={{ overflow: "hidden", textAlign: "center" }}>
                <TextareaAutosize
                  minRows={5}
                  value={dialogCommentsValue}
                  onChange={handleDialogInputChange}
                  className=""
                  style={{ width: "350px", minWidth: "350px" }}
                  // disabled={currentCommentsIndex!=selectedRowIndex}
                />
                {oldConcatenatedComment && (
                  <div
                    style={{
                      textWrap: "wrap",
                      backgroundColor: "rgb(175, 171, 170)",
                      marginTop: "10px",
                      padding: "20px",
                      borderRadius: "5px",
                      whiteSpace: "pre-wrap",
                      textAlign: "left",
                      maxHeight:"300px",
                      overflowY:"scroll",
                      maxWidth:"400px"
                    }}
                  >
                    {(() => {
                      const commentsData = safeParseJson(oldConcatenatedComment);
                      if (Array.isArray(commentsData)) {
                        return commentsData.map((comment, index) => (
                          <div key={index} style={{ marginBottom: "10px", borderBottom: "1px solid #ccc", paddingBottom: "8px" }}>
                            <div style={{ marginBottom: "4px" }}>
                              <strong>Value:</strong> {String(comment.value || "")}
                            </div>
                            <div style={{ marginBottom: "4px" }}>
                              <strong>Date:</strong> {String(comment.date || "")}
                            </div>
                            <div>
                              <strong>By:</strong> {String(comment.by || "")}
                            </div>
                          </div>
                        ));
                      }
                      return String(oldConcatenatedComment || "");
                    })()}
                  </div>
                )}
              </DialogContent>

              <DialogActions>
                <CommonButton
                  text="Cancel"
                  handleClick={handleCloseDialogs}
                  sx={{
                    backgroundColor: "#ffff",
                    color: "#000000",
                    border: "1px solid #BCBDBF",
                  }}
                />
                <CommonButton
                  text="Ok"
                  handleClick={(e) => {
                    const textarea = e.target.closest('.MuiDialog-root').querySelector('textarea');
                    handleSaveComments(textarea?.value);
                  }}
                  hoverColor="#FF5A01"
                  disabled={!dialogCommentsValue}
                />
              </DialogActions>
            </Dialog>
          </Box>
        )
        : <div style={{paddingTop: "35%", textAlign: "center"}}>You are not authorized to view this page.</div>
      }
      </div>

      <Dialog
        open={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            setIsFilterOpen(false);
            handleSearchBnkReconciliationList();
          }
        }}
        PaperProps={{
          sx: {
            width: '50vw',
            height: '80vh',
            maxWidth: 'none',
            maxHeight: 'none',
            position: 'absolute',
            top: '10%',
            right: '20%',
          }
        }}
      >
        <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <Typography variant="h6">Filters</Typography>
          <IconButton onClick={() => setIsFilterOpen(false)} aria-label="Close filters">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <FormLabel>Broker Branch</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select Broker"
                value={searchFieldsPrams?.Broker  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("Broker", value, reason, true)}
                options={brokerList || []}
              />
            </Grid>

            <Grid item xs={6}>
              <FormLabel>LOB</FormLabel>
              <CommonSelect
                placeholder="Select LOB"
                value={searchFieldsPrams?.lob  || ""}
                handleChange={(event, value, reason) => handleFilterDropdown("lob", value, reason)}
                options={lobList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>YOA</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select YOA"
                value={searchFieldsPrams?.yoa  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("yoa", value, reason, true)}
                options={yoaList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Policy Ref</FormLabel>
              <CommonSelect
                placeholder="Select Policy Ref"
                handleChange={(event, value, reason) => handleFilterDropdown("policy_ref", value, reason)}
                handleInputChage={(value) => handleInputChage(value)}
                options={policyOptions?.map((option) => option?.policy_id)}
                value={policyNumber}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Mapped MOP</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select MOP Mapped"
                value={searchFieldsPrams?.mop_mapped  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("mop_mapped", value, reason, true)}
                options={MOPMappedList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Market Source</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select Market Source"
                value={searchFieldsPrams?.market_source  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("market_source", value, reason, true)}
                options={marketSourceList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Broker Reference</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select Broker Reference"
                value={searchFieldsPrams?.broker_reference  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("broker_reference", value, reason, true)}
                options={brokerReferenceList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Insured</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select Insured"
                value={searchFieldsPrams?.insured  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("insured", value, reason, true)}
                options={insuredList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>UMR</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select UMR"
                value={searchFieldsPrams?.umr  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("umr", value, reason, true)}
                options={umrList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>File Name</FormLabel>
              <CommonSelect
                placeholder="Select file name"
                value={searchFieldsPrams?.file_name ?? ""}
                handleChange={(event, value, reason) => handleFilterDropdown("file_name", value, reason)}
                options={fileNameList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Entity</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select Entity"
                value={searchFieldsPrams?.entity || []}
                handleChange={(event, value, reason) => handleFilterDropdown("entity", value, reason, true)}
                options={entityList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Underwriter</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select underwriter"
                value={searchFieldsPrams?.underwriter  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("underwriter", value, reason, true)}
                options={underWriterList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Status Sett</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select status_sett"
                value={searchFieldsPrams?.status_sett  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("status_sett", value, reason, true)}
                options={statusSettList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Status USD</FormLabel>
              <CommonSelect
                multiple={true}
                placeholder="Select status_usd"
                value={searchFieldsPrams?.status_usd  || []}
                handleChange={(event, value, reason) => handleFilterDropdown("status_usd", value, reason, true)}
                options={statusUSDList || []}
              />
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Inception Date</FormLabel>
              <div onKeyUp={(e) => handleEnter(e)}>
              <CustomDateRangePicker
                startDate={fromInceptionDateValue}
                setStartDate={setFromInceptionDateValue}
                endDate={toInceptionDateValue}
                setEndDate={setToInceptionDateValue}
                maxDate={new Date()}
                customWidth={"95%"}
              />
              </div>
            </Grid>

            <Grid item xs={6} sx={{ mt: 1 }}>
              <FormLabel>Due Date</FormLabel>
              <div onKeyUp={(e) => handleEnter(e)}>
              <CustomDateRangePicker
                startDate={fromDueDateValue}
                setStartDate={setFromDueDateValue}
                endDate={toDueDateValue}
                setEndDate={setToDueDateValue}
                // maxDate={null}
                customWidth={"95%"}
              />
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", p: 2 }}>
          <CommonButton
            text="Close"
            handleClick={() => setIsFilterOpen(false)}
            hoverColor="#EE3F00"
          />
          <CommonButton
            text="Apply Filters"
            handleClick={() => {
              setIsFilterOpen(false);
              handleSearchBnkReconciliationList();
            }}
            hoverColor="#EE3F00"
            disabled={pageState?.isLoading || isFilterBtnDisable()}
          />
        </DialogActions>
      </Dialog>
      </>
    );
  };
